import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, TextField, Link, Snackbar } from '@mui/material';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';

function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async () => {
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      console.log('User signed up successfully');
      // await userCredential.user.sendEmailVerification(); // Access userCredential here
      navigate('/welcome', { state: { signupSuccess: true, email } });
    } catch (error) {
      console.error('Error signing up:', error.message);
      setErrorMessage(error.message);
      setSnackbarOpen(true);
    }
  };
  

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={<Typography>{errorMessage}</Typography>} // This line has been adjusted to include Typography for consistency
        key={'topcenter'}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          width: '30%',
          borderRadius: '20px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          padding: '50px',
        }}
      >
        <Card sx={{ borderRadius: '10px' }}>
          <CardMedia
            component="img"
            image="/logo.png"
            sx={{ width: 80, height: 80 }}
          />
        </Card>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Create an Account
        </Typography>
        <TextField
          label="Email"
          variant="outlined"
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ width: '100%', backgroundColor: '#F5F5F5' }}
        />
        <TextField
          label="Password"
          variant="outlined"
          size="small"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ width: '100%', backgroundColor: '#F5F5F5' }}
        />
        <Button variant="contained" onClick={handleSignUp} sx={{ backgroundColor: '#4CAF50', borderRadius: '10px', minWidth: "100px", minHeight: '50px' }}>
          Sign Up
        </Button>
        <Typography variant="body2" sx={{ marginTop: 2 }}>
          Already have an account?{' '}
          <Link component="button" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            Log in
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default SignUp;
